import { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { PageLayout } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ContactsMenu } from 'pages/contacts/ui/ContactsMenu'
import {
  ProviderContactsPageLayout,
  useContactsPageLayoutContext,
} from 'pages/contacts/context/contactsPageLayoutContext'
import { ContactsPageLayoutStore } from 'pages/contacts/store/contactsPageLayoutStore'

const ContactsLayoutContent = observer(() => {
  const { contactsMenuStore, pageLayoutStore } = useContactsPageLayoutContext()
  const { contactsStore } = useEntitiesContext()

  useEffect(() => {
    return () => {
      contactsStore.reset()
    }
  }, [])

  return (
    <PageLayout store={pageLayoutStore} leftContent={<ContactsMenu store={contactsMenuStore} />} />
  )
})

export const ContactsLayout = () => {
  const entities = useEntitiesContext()
  const contactsPageLayoutStore = useMemo(() => new ContactsPageLayoutStore(entities), [])

  return (
    <ProviderContactsPageLayout value={contactsPageLayoutStore}>
      <ContactsLayoutContent />
    </ProviderContactsPageLayout>
  )
}
